<template>
  <app-modal modal-id="change-modal"
             modal-size="medium"
             modal-alignment="top"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">
        {{ selectedUrl ? $t("gantt_change_date_title") : $t("add_leson") }}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form ref="form" v-if="dataLoaded" :data-url="selectedUrl">
        <div class="form-group">
          <div class="row">
            <div class="mb-0 col-12 col-md-5 d-flex align-items-center">
              <label>{{ $t("gantt_change_date") }}</label>
            </div>
            <div class="col-12 col-md-7">
                <app-input
                      type="date"
                      :popover-position="'bottom-start'"
                      :placeholder="$t('start_date')"
                      :required="true"
                      v-model="formData.change"
                    />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-row">
            <app-note :title="$t('gantt_note_title')" note-type="note-success" :notes="[$t('gantt_note')]"/>
    
          </div>
        </div>
     
      

        
         
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button type="button" class="btn btn-primary" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import {mapGetters} from "vuex";
import { collect } from "@app/Helpers/Collection";
import moment from "moment";

export default {
  name: "LesonModal",
  mixins: [FormSubmitMixin],
  props: {
    start: String,
  },
  data() {
    return {
      dataLoaded: true,
      countryList: [],
      addEditData: {
        
      },
      formData:{
        change:''
      },
     
     
    };
  },
  computed: {

  },
  methods: {
 
    
    beforeSubmit() {
      this.loading = true;
    },
    submit() {
    
      


      this.addEditData = this.formData;



   
      
      this.save(this.addEditData);
    },

    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$emit('update-request');
      this.closeModal();
    },
    afterSuccessFromGetEditData(response) {
        
      this.formData = response.data;
      this.formData.change = this.start ? moment(this.start, "DD.MM.YYYY").format('YYYY-MM-DD') : new Date();
      this.formData.started_date = moment(this.start, "DD.MM.YYYY").format('YYYY-MM-DD');
      this.dataLoaded = true;                  
  
    
    },
  },
  mounted() {
    

  },
};
</script>
